import type { ItemRenderer } from "./types";

export const renderCabinet: ItemRenderer = ({ svg, bboxPx }) => {
    const color = "#a64022";

    const frameStroke = 0.45;
    const frame = {
        x: bboxPx.x + frameStroke / 2,
        y: bboxPx.y + frameStroke / 2,
        w: Math.max(0, bboxPx.w - frameStroke),
        h: Math.max(0, bboxPx.h - frameStroke),
    };

    svg.rect(frame.w, frame.h).move(frame.x, frame.y).fill("#fff").stroke({ width: frameStroke, color });

    const seamStroke = 0.7;
    const seamMinX = frame.x + seamStroke / 2;
    const seamMaxX = frame.x + frame.w - seamStroke / 2;

    let seamX = bboxPx.x + bboxPx.w * 0.35;
    seamX = Math.max(seamMinX, Math.min(seamX, seamMaxX));

    const seamY1 = frame.y + seamStroke / 2;
    const seamY2 = frame.y + frame.h - seamStroke / 2;

    svg.line(seamX, seamY1, seamX, seamY2).stroke({ width: seamStroke, color, linecap: "butt" });

    const knobR = Math.max(1.5, Math.min(3, Math.min(frame.w, frame.h) * 0.04));
    const knobXPref = seamX + Math.max(6, frame.w * 0.04);
    const knobX = Math.max(frame.x + knobR, Math.min(knobXPref, frame.x + frame.w - knobR));
    const knobY = Math.max(frame.y + knobR, Math.min(frame.y + frame.h * 0.5, frame.y + frame.h - knobR));

    svg.circle(knobR * 2)
        .center(knobX, knobY)
        .fill(color);
};
